module.exports = __webpack_public_path__ + "media/brands/sam-640867a7.png";